import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const PriceFilter = ({ setFiltersAndSort, filtersAndSort, noApply }) => {
  const [price, setPrice] = useState(filtersAndSort.price);

  useEffect(() => {
    setPrice(filtersAndSort.price);
  }, [filtersAndSort]);

  const handleSubmit = () =>
    setFiltersAndSort(prev => ({
      ...prev,
      price: {
        min: price.min,
        max: price.max,
        currency: price.currency
      }
    }));

  return (
    <div className="d-flex gap-sm-3 gap-lg-0 flex-column flex-sm-row flex-lg-column mt-0 justify-content-betweenm align-items-start align-items-lg-start">
      <Form.Group>
        <Form.Label>Precio</Form.Label>

        <div className="d-flex gap-3">
          <div className="d-flex align-items-center gap-1">
            <Form.Check
              type="radio"
              name="currency"
              id="ars"
              onChange={() => {
                if (noApply) {
                  setFiltersAndSort(prev => ({
                    ...prev,
                    price: {
                      ...prev.price,
                      currency: 'ARS'
                    }
                  }));
                } else {
                  setPrice(state => ({ ...state, currency: 'ARS' }));
                }
              }}
              checked={price.currency === 'ARS'}
              className="m-0"
            />
            <label style={{ marginTop: 2, marginBottom: 0 }}>ARS</label>
          </div>

          <div className="d-flex align-items-center gap-1">
            <Form.Check
              type="radio"
              name="currency"
              id="usd"
              onChange={() => {
                if (noApply) {
                  setFiltersAndSort(prev => ({
                    ...prev,
                    price: {
                      ...prev.price,
                      currency: 'USD'
                    }
                  }));
                } else {
                  setPrice(state => ({ ...state, currency: 'USD' }));
                }
              }}
              checked={price.currency === 'USD'}
              className="m-0"
            />

            <label style={{ marginTop: 2, marginBottom: 0 }}>USD</label>
          </div>
        </div>
      </Form.Group>

      <div className="d-flex flex-column flex-sm-row gap-2 w-100">
        <Form.Group className="w-100">
          <Form.Label className="fs--2">Desde</Form.Label>
          <InputGroup>
            <InputGroup.Text className="px-2 fs--1">$</InputGroup.Text>
            <Form.Control
              type="number"
              size="sm"
              value={price.min}
              onChange={e => {
                if (noApply) {
                  setFiltersAndSort(prev => ({
                    ...prev,
                    price: {
                      ...prev.price,
                      min: e.target.value
                    }
                  }));
                } else {
                  setPrice(state => ({
                    ...state,
                    min: e.target.value
                  }));
                }
              }}
            />
          </InputGroup>
        </Form.Group>

        <Form.Group className="w-100">
          <Form.Label className="fs--2">Hasta</Form.Label>

          <InputGroup>
            <InputGroup.Text className="px-2 fs--1">$</InputGroup.Text>
            <Form.Control
              type="number"
              size="sm"
              value={price.max}
              onChange={e => {
                if (noApply) {
                  setFiltersAndSort(prev => ({
                    ...prev,
                    price: {
                      ...prev.price,
                      max: e.target.value
                    }
                  }));
                } else {
                  setPrice(state => ({
                    ...state,
                    max: e.target.value
                  }));
                }
              }}
            />
          </InputGroup>
        </Form.Group>
      </div>

      {!noApply && (
        <div className="mt-3 d-flex flex-column flex-sm-row gap-2 w-100 w-sm-50 w-lg-100 mt-sm-4 mt-lg-2">
          <Button
            className="w-100 w-sm-auto"
            style={{ flexGrow: 1 }}
            size="sm"
            variant="primary"
            onClick={handleSubmit}
          >
            Aplicar
          </Button>
          <Button
            className="w-100 w-sm-auto"
            style={{ flexGrow: 1 }}
            size="sm"
            variant="secondary"
            onClick={() => {
              setFiltersAndSort(prev => ({
                ...prev,
                price: {
                  min: '',
                  max: '',
                  currency: 'ARS'
                }
              }));
            }}
          >
            Limpiar
          </Button>
        </div>
      )}
    </div>
  );
};
PriceFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  noApply: PropTypes.bool
};
